import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-datepicker-row',
  templateUrl: './datepicker-row.component.html',
  styleUrl: './datepicker-row.component.scss'
})
export class DatepickerRowComponent {
  @Input({ required: true }) label: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: true }) errorMessage: string;
  @Input({ required: true }) control: FormControl;
  @Input({ required: false }) width = "30%";
  @Input({ required: false }) isTimeOnly = false;
  @Input({ required: false }) isDateTime = false;
  @Input({ required: false }) minDate: string | Date | null = null;
  @Input({ required: false }) maxDate: string | Date | null = null;
  /** 'auto' = open up by default; flip with wizard coach when needed (see WizardCoachOverlayUiService). */
  @Input({ required: false }) drops: 'auto' | 'up' | 'down' = 'auto';

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }
}
